import { RouterConfig, inject, needs, Navigator } from "fw";
import { RequireAuth } from "router-middleware/require-auth";
import { CurrentUserStore } from "state/current-user";
import { Login } from "views/login/login";
import { ResetPassword } from "views/login/reset-password";
import { Search } from "views/search/search";
import { ActivityAlert } from "components/activity-alert";
import { ConfirmDialog } from "components/confirm-dialog";
import { ConfirmChangeEmail } from "views/login/confirm-change-email";

@inject
@needs(ActivityAlert, ConfirmDialog)
export class App {
    router: RouterConfig;

    constructor(
        private currentUser: CurrentUserStore,
        private nav: Navigator
    ) {}

    registerRoutes(r: RouterConfig) {
        r.addMiddleware(RequireAuth);

        r.add("components", () => import("./views/settings/components"), { auth: true });
        r.add("settings", () => import("./views/settings/settings"), { auth: true });
        r.add("monitor", () => import("./views/monitor/monitor"), { auth: true });

        r.add("login", Login);
        r.add("reset-password/:token", ResetPassword);

        r.add("change-email/:token", ConfirmChangeEmail);

        r.add("organizations", () => import("./views/organizations/organization-routes"), { auth: true });
        r.add("", Search, { auth: true });
        this.router = r;
    }

    get fadeTransition() {
        return {
            functional: true,
            render(h, context) {
                return h("transition-group", { props: { name: "fade-shrink-in", mode: "out-in" } }, context.children);
            }
        };
    }
}
